import {
  VuexModule,
  Module,
  getModule,
  MutationAction,
  Mutation,
  Action,
} from "vuex-module-decorators";
import store from "@/store";
import { AuthService } from "@/services/auth.service";
import { UserPermissions } from "@/config/consts";
import { EmailService } from "@/services/api/email.service";
import { SecretHash } from "~/secret_hash";
import { RestorePassw, UpdatePassword } from "~/update_password";

@Module({ dynamic: true, store, name: "auth" })
export class AuthVuexModule extends VuexModule {
  user: IUser | null = null;
  isLoggedIn: boolean = true;
  permissions: string[] = [];
  HS: SecretHash = null as any;
  enter_types: number = 0;
  ShowInstruction: boolean = false;
  ShowInstructionSignAct: boolean = false;
  ShowConsumptionNotification: boolean = false;

  @Mutation
  public async setShowInstruction(val: boolean) {
    this.ShowInstruction = val;
  }

  @Mutation
  public async setShowInstructionSignAct(val: boolean) {
    this.ShowInstructionSignAct = val;
  }
  @Mutation
  public async setShowConsumptionNotification(val: boolean) {
    this.ShowConsumptionNotification = val;
  }

  @Mutation
  public async setEnter_types(value: number) {
    this.enter_types = value;
  }

  get isEmailMutationAvailable() {
    return this.permissions.includes(UserPermissions.ACCESS_ORGANIZATION);
  }

  get hasPermissionTo() {
    return (action: string) => {
      if (action) {
        return this.permissions.length
          ? this.permissions.includes(action)
          : false;
      } else {
        return true;
      }
    };
  }

  @Mutation
  public setIsLoggedIn(value: boolean) {
    this.isLoggedIn = value;
  }

  @Mutation
  public setUser(user: IUser) {
    this.user = user;
  }

  @MutationAction
  public async getUser() {
    const response = await AuthService.getUser();
    if (response.status != 200) {
      await AuthService.logout();
      return { user: null };
    }

    return {
      user: response.data,
    };
  }

  @Action
  public async setPassword() {
    await EmailService.setPassword();
  }

  @Action
  public async restorePassword(req: RestorePassw) {
    return await EmailService.restorePassword(req.email, req.bin);
  }

  @Action
  public async isSercretHashExists(secretHash: string) {
    return await EmailService.isSercretHashExists(secretHash);
  }

  @Action
  public async updatePassword(req: UpdatePassword) {
    return await EmailService.updatePassword(req.secretHash, req.password);
  }

  @MutationAction
  public async getPermissions() {
    //const permissions = await AuthService.getPermissions();
    const permissions = [
      "accessOrganization",
      "signReconciliationAct",
      "rejectInvoiceAct",
      "rejectReconciliationAct",
      "signInvoiceAct",
      "accessAccept",
      "showReconciliationAct",
      "showInvoiceAct",
      "showReconciliationActNetto",
      "showContractVie",
      "showInvoice",
      "feedback",
      "userManagement",
      "showSendCounts",
    ];

    return {
      permissions,
    };
  }
}

export const AuthModule = getModule(AuthVuexModule);
